import BaseNetService from '../base/BaseNetService';

export default class PointsNetService extends BaseNetService {
  deleteCityPoints(options) {
    return this.api.deleteCityPoints(options);
  }
} 